/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js'; // Included with Angular CLI. // Run `npm install --save web-animations-js`.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
// import 'intl';  // Run `npm install --save intl`.
/**
 * Need to import at least one locale-data with intl.
 */
// import 'intl/locale-data/jsonp/en';
(window as any).global = window;

if (typeof requestIdleCallback === 'undefined') {
	(window as any).requestIdleCallback = (cb: IdleRequestCallback) => setTimeout(cb, 200);
}

// Object.hasOwn was added in Chrome 93. Polyfill for Chrome OS 91 and older.
if (!Object.hasOwn) {
	Object.hasOwn = (obj: object, prop: PropertyKey) => Object.prototype.hasOwnProperty.call(obj, prop);
}
